import React from "react";

export default function About() {
  return (
    <div className="main-page">
      <h2>
        About Shiba Sensei: Igniting a Passion for Japanese Language Mastery
      </h2>
      <p>
        At Shiba Sensei, our journey began with a burning passion for Japanese
        language and an unwavering desire to make learning Japanese vocabulary
        an immersive and effective experience. Inspired by the challenges faced
        during our own study of Japanese, we set out to create a web app that
        would revolutionize the way language learners approached vocabulary
        practice.
      </p>
      <h3>The Genesis of Shiba Sensei: A Personal Quest</h3>
      <p>
        As language enthusiasts and avid students of Japanese, we discovered
        that traditional language learning methods, such as flashcards and
        repetitive drills, lacked the engagement and practicality we craved. We
        yearned for a dynamic and interactive platform that mirrored real-life
        language usage, allowing us to type in responses and encounter words in
        meaningful contexts.
      </p>
      <h3>The Vision Unveiled: A New Path to Proficiency</h3>
      <p>
        Driven by our dedication to promoting authentic language learning, we
        embarked on a mission to develop a web app that combined cutting-edge
        technology with the proven effectiveness of spaced repetition. Shiba
        Sensei was born - a platform that would harness the power of typing
        exercises and spaced repetition to ignite a passion for Japanese
        language mastery like never before.
      </p>
      <h3>The Shiba Sensei Difference: Interactive Learning Redefined</h3>
      <p>
        Shiba Sensei stands apart by offering an engaging and user-friendly
        learning experience. Say farewell to monotonous memorization and embrace
        the thrill of interactive typing exercises that simulate real
        conversations. Our platform adapts to your progress, ensuring you
        encounter vocabulary at precisely timed intervals for optimal retention.
      </p>
      <h3>Our Commitment to Your Success: A Growing Word Library</h3>
      <p>
        With the aim to cater to learners of all levels, Shiba Sensei's word
        library is continuously expanding. From fundamental Japanese words for
        beginners to sophisticated expressions for advanced learners, we strive
        to provide a comprehensive and ever-evolving resource for all language
        enthusiasts.
      </p>
      <h3>Your Learning Journey, Your Pace: Flexibility at Its Finest</h3>
      <p>
        At Shiba Sensei, we celebrate individuality and respect that every
        learner has their own pace. Whether you're a dedicated language student
        or squeezing in study time amidst a busy schedule, our platform empowers
        you to tailor your learning journey according to your preferences.
      </p>
      <h3>Embark on a Journey of Excellence: The Future Awaits</h3>
      <p>
        We are thrilled to share Shiba Sensei with the world - a dream come true
        for Japanese language learners seeking an extraordinary path to
        proficiency. Our passion lies in unlocking the potential of learners
        like you, guiding you on a transformative journey to fluency and
        cultural connection.
      </p>
      <h3>Join the Shiba Sensei Community: Ignite Your Japanese Adventure!</h3>
      <p>
        We welcome you to embrace the richness of the Japanese language with
        Shiba Sensei. Unlock the true essence of Japanese vocabulary through our
        innovative web app, and embark on an adventure that will open doors to
        endless possibilities in culture, communication, and personal growth.
      </p>
      <h3>Let's Conquer Japanese Together: Join Shiba Sensei Today!</h3>
      <p>
        As we continue to evolve and expand, we invite you to be a part of the
        Shiba Sensei community. Together, we will revolutionize language
        learning and inspire a new generation of Japanese language enthusiasts.
      </p>
      <p>
        Start your journey with Shiba Sensei now, and unleash the language
        enthusiast within you. Welcome to a world of Japanese vocabulary mastery
        like never before!
      </p>
    </div>
  );
}
